<div
  style="width: 100%"
  class="d-flex flex-column align-items-center justify-content-between"
>
  <app-admin-header
    style="width: 100%"
    [header]="header"
    [links]="links"
    [breadcrumbs]="breadcrumbs"
    [queryParams]="queryParams"
    [stats]="stats"
  ></app-admin-header>

  <div class="w-100">
    <!-- skelition   -->
    <app-skelitions
      [hidden]="!skelition"
      [value]="2"
      class="mb-2"
    ></app-skelitions>
    <div class="container-fluid mb-5 px-5 pt-5 111" *ngIf="!skelition">
      <app-training-certificate
        [editFlag]="false"
        [certType]="2"
        [assessmentId]="assessmentId"
        [userTesting]="isUserTesting"
        [courseId]=""
        [email]="email"
        [download]="download"
      ></app-training-certificate>
    </div>
  </div>
</div>
<app-footer></app-footer>
